import { BrowserEvents, loadingBar } from '../global/constants';

;(function($) {

	$(document).ready(function() {

		// ---------- Handle Form ----------

		function handleForm(form, params) {

			const formContent = form.find('.form-content');
			const formDone = form.find('.form-done');
			const formSuccess = formDone.find('.success');
			const formError = formDone.find('.error');
			const formButton = form.find('button[type=submit]');
			const date = form.find('input[name=date]');

			$(document).on('click', '.wpsbc-date.wpsbc-legend-item-1, .wpsbc-date.wpsbc-legend-item-6, .wpsbc-date.wpsbc-legend-item-9, .wpsbc-date.wpsbc-legend-item-10', function() {
				date.val(this.dataset.day + '-' + this.dataset.month + '-' + this.dataset.year);
			});

			form.find('[name=date]').datepicker({
				container: form.find('.date-picker'),
				inline: true,
				autoPick: false,
				language: 'fr-FR',
				format: 'dd-mm-yyyy',
				filter: (params === chambres_reservation_params) ? (date, view) => {

					const currentMonth = date.getMonth();
					const currentDay = date.getDate();
					const closedMonths = !(currentMonth > 2 && currentMonth < 11);
					const openedDays = (currentMonth === 3 && currentDay < 2) || (currentMonth === 10 && currentDay > 15);

					if(view === 'day' && closedMonths || openedDays) {
						return false;
					}

					return true;

				} : null,
			});

			form.parsley().on('form:submit', function() {

				loadingBar.classList.add('active');

				const formData = new FormData(form[0]);
				formData.append('action', params.action);
				formData.append('nonce', params.nonce);

				formButton.attr('disabled', true);

				$.ajax({
					url: params.url,
					type: 'POST',
					dataType: 'json',
					data: formData,
					processData: false,
					contentType: false,
				}).always(function(response) {

					loadingBar.classList.remove('active');
					formContent.addClass('d-none');
					formDone.removeClass('d-none');
					formButton.attr('disabled', false);

					if(response.success === true) {
						formSuccess.removeClass('d-none');

						if(typeof gtag === 'function') {
							gtag('event', 'reservation', {
								'event_category': 'formulaire',
								'event_label': ((params === chambres_reservation_params) ? 'reservation_relais' : 'reservation_visites')
							});
						}
					}
					else {
						formError.removeClass('d-none');
						console.error(response);
					}
				});

				return false;
			});
		}

		// ---------- Visit Form ----------

		if(typeof visites_reservation_params !== 'undefined') {

			$('#visites-form-modal').on('show.bs.modal', function(e) {
				const self = $(this);
				const visite = $(e.relatedTarget).data('visite');

				if(typeof gtag === 'function') {
					gtag('event', 'intention_reservation', {
						'event_category': 'formulaire',
						'event_label': 'open_form_visites'
					});
				}

				self.find('select[name=visite]').val(visite);
				self.find('.form-content').removeClass('d-none');
				self.find('.form-done, .form-done .success, .form-done .error').addClass('d-none');
			});

			$('form#visites-form').each(function() {
				handleForm($(this), visites_reservation_params);
			});
		}

		// ---------- Chambre Form ----------

		if(typeof chambres_reservation_params !== 'undefined') {

			$('#chambres-form-modal').on('show.bs.modal', function(e) {
				const self = $(this);
				const chambre = $(e.relatedTarget).data('chambre');

				if(typeof gtag === 'function') {
					gtag('event', 'intention_reservation', {
						'event_category': 'formulaire',
						'event_label': 'open_form_relais'
					});
				}

				self.find('select[name=chambre]').val(chambre);
				self.find('.form-content').removeClass('d-none');
				self.find('.form-done, .form-done .success, .form-done .error').addClass('d-none');
			});

			$('form#chambres-form').each(function() {
				handleForm($(this), chambres_reservation_params);
			});
		}
	});

}(jQuery));
